import { render, staticRenderFns } from "./SectionTeam.vue?vue&type=template&id=6a3b6c01&"
import script from "./SectionTeam.vue?vue&type=script&lang=js&"
export * from "./SectionTeam.vue?vue&type=script&lang=js&"
import style0 from "./SectionTeam.vue?vue&type=style&index=0&id=6a3b6c01&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports